<div class="sidesheet-wrapper">
  <ng-template appSideSheetContent></ng-template>
</div>
